const TOKEN_KEY = 'ersr-token'
const SESSION_TTL_MS = 1000 * 60 * 60 * 24 * 30

type StoredSession = {
  token: string
  expiresAt: number
}

function buildSession(token: string): StoredSession {
  return {
    token,
    expiresAt: Date.now() + SESSION_TTL_MS,
  }
}

function parseStoredSession(value: string): StoredSession | null {
  try {
    const parsed = JSON.parse(value) as Partial<StoredSession>
    if (typeof parsed.token === 'string' && typeof parsed.expiresAt === 'number') {
      return parsed as StoredSession
    }
  } catch {
    if (value !== '') {
      return buildSession(value)
    }
  }

  return null
}

export function getToken(): string | null {
  if (typeof localStorage === 'undefined') return null

  const value = localStorage.getItem(TOKEN_KEY)
  if (value === null) return null

  const session = parseStoredSession(value)
  if (session === null || session.expiresAt <= Date.now()) {
    clearToken()
    return null
  }

  localStorage.setItem(TOKEN_KEY, JSON.stringify(session))
  return session.token
}

export function setToken(token: string) {
  if (typeof localStorage === 'undefined') return
  localStorage.setItem(TOKEN_KEY, JSON.stringify(buildSession(token)))
}

export function clearToken() {
  if (typeof localStorage === 'undefined') return
  localStorage.removeItem(TOKEN_KEY)
}
